// 21.2.5.3 get RegExp.prototype.flags()
if (require('./_descriptors') && /./g.flags != 'g') require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es6.regexp.flags.js
// module id = 588
// module chunks = 168707334958949